// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithIcon_button__hVaXr","buttonText":"ButtonWithIcon_buttonText__M0r6k"};